import { render } from "./notificationView.vue?vue&type=template&id=17431e16"
import script from "./notificationView.vue?vue&type=script&lang=js"
export * from "./notificationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__